export enum NewsPublishLocationsEnum {
    All = 'All',
    WebsiteBlog = 'Website Blog',
    StudentPortal = 'Student Portal',
    TeacherPortal = 'Teacher Portal'
}